var scope_0 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4369103d9a8d8f355236d48bde13929d.js').default;
var scope_1 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/65e8c33352582be55bda88873f45b03e.js').default;
var scope_2 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    